import { render, staticRenderFns } from "./WatcherInfo.vue?vue&type=template&id=2b001b47&scoped=true"
import script from "./WatcherInfo.vue.js?vue&type=script&lang=js&external"
export * from "./WatcherInfo.vue.js?vue&type=script&lang=js&external"
import style0 from "./WatcherInfo.vue?vue&type=style&index=0&id=2b001b47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b001b47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VMenu,VRadio,VRadioGroup,VSelect,VTextField})
